export default "__VITE_ASSET__u$ErANqJ__"